export const text = {
  upload: "Upload New Image",
};
